"use strict";
exports.__esModule = true;
exports.INCOME_VERIFICATION_JUST_A_LITTLE_LONGER = void 0;
exports.INCOME_VERIFICATION_JUST_A_LITTLE_LONGER = {
    HEADER: 'Just a little longer!',
    BODY_1: 'We need a bit more time to process your application.',
    BODY_2: 'Please check back in 3-6 hours for an update.'
};
